import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ displayState }) => css`
    ${({ theme }) => css`
      min-width: 280px;
      min-height: 42px;
      border: ${displayState?.redBorder ? '1px solid #FD2020' : '1px solid #E3E3E3'};
      border-radius: 8px;
      padding: 0px 12px;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
      background-color: #FFFFFF;
      &:hover {
        border: 1px solid ${theme?.colour?.primary ?? "#1DBD6B"};
      }
      
      @media only screen and (min-width: 768px) {
        min-width: 320px;
      }
    `}
  `}
`;

export default Wrapper(template);